export default "__VITE_ASSET__khNvMxm4__"